module.exports = __webpack_public_path__ + "896b59554a2611c39027bbaec700aab3.png";